import React from 'react';
import MuiMenuList, {
	type MenuListProps as MuiMenuListProps,
} from '@mui/material/MenuList';

export interface MenuListProps extends Partial<MuiMenuListProps> {}

export const MenuList = React.forwardRef<HTMLUListElement, MenuListProps>(
	(props, ref) => <MuiMenuList {...props} ref={ref} />,
);

export default MenuList;
